import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import Link from '../Global/Link';
import ImageHandler from '../../utils/ImageHandler';
import { TextTruncate } from '../../utils/TextTruncate';

// ====

const CardNews = (props) => {
  const { title, image, category, date, copy, link } = props;

  // ====

  return (
    <div className="col-12 col-md-6 brand-col">
      <div className="card h-100 brand-card-image-right">
        <div className="card-header border-0 p-0">
          <div
            className="brand-card-image brand-background-cover"
            style={{
              backgroundImage: `url(${ImageHandler(image, '500x500')})`,
            }}
          />
        </div>
        <div className="card-body">
          {category && (
            <p>
              <span className={`brand-label brand-label-${category}`}>
                {category}
              </span>
            </p>
          )}
          {title && <h4 className="brand-font-caps">{title}</h4>}
          {date && (
            <p className="brand-font-caps small brand-text-grey">
              Posted on <Moment format="DD MMMM YYYY">{date}</Moment>
            </p>
          )}
          <p>{TextTruncate(copy, 80)}</p>
          <Link stretched to={`/news/${link}/`} />
        </div>
      </div>
    </div>
  );
};

export default CardNews;

// ====

CardNews.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  category: PropTypes.string,
  date: PropTypes.string,
  copy: PropTypes.string,
  link: PropTypes.string,
};

CardNews.defaultProps = {
  title: null,
  image: null,
  category: null,
  date: null,
  copy: null,
  link: null,
};
